import { handleRequest } from "../utilities/requestHandler";


export const acceptEula = (userId, eulaAccepted, documentIds = []) => 
    handleRequest("post", "/auth/eula-accept", {
        user_id: userId,
        eula_accepted: eulaAccepted,
        document_ids: documentIds,
    });
